var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowrStudioFollowr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "block"
    },
    viewBox: "240 630 1570 475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FBase",
    gradientUnits: "userSpaceOnUse",
    x1: 389.889,
    y1: 1491.54,
    x2: 1214.01,
    y2: 989.524
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop0",
    offset: 0,
    stopOpacity: 1,
    stopColor: "rgb(22,27,79)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: 1,
    stopOpacity: 1,
    stopColor: "rgb(82,55,135)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FMid",
    gradientUnits: "userSpaceOnUse",
    x1: 431.963,
    y1: 991.209,
    x2: 858.552,
    y2: 571.343
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop0",
    offset: 0,
    stopOpacity: 1,
    stopColor: "rgb(40,35,93)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: 1,
    stopOpacity: 1,
    stopColor: "rgb(93,60,147)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FTop",
    gradientUnits: "userSpaceOnUse",
    x1: 927.432,
    y1: 704.758,
    x2: 1402.12,
    y2: 235.468
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop0",
    offset: 0,
    stopOpacity: 1,
    stopColor: "rgb(93,59,149)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: 1,
    stopOpacity: 1,
    stopColor: "rgb(133,83,185)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient2",
    gradientUnits: "userSpaceOnUse",
    x1: 1097.78,
    y1: 917.111,
    x2: 1262.5,
    y2: 769.849
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop0",
    offset: 0,
    stopOpacity: 1,
    stopColor: "rgb(113,69,180)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: 1,
    stopOpacity: 1,
    stopColor: "rgb(149,84,197)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient3",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.3,
    y1: 908.423,
    x2: 1626.55,
    y2: 714.023
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop0",
    offset: 0,
    stopOpacity: 1,
    stopColor: "rgb(146,82,197)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: 1,
    stopOpacity: 1,
    stopColor: "rgb(177,103,204)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.4 545.55) scale(0.31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#FTop)",
    d: "M 640.851 388.247 C 646.564 382.283 669.294 367.565 677.04 362.772 C 743.791 321.212 820.533 298.463 899.149 296.931 C 1001.36 294.785 1107.95 296.22 1210.5 296.124 L 1315.1 296.159 C 1348.84 296.241 1382.48 295.115 1415.64 301.843 C 1459.44 310.732 1498.02 331.152 1530.4 361.993 C 1580.83 410.017 1604.72 464.576 1605.93 534.368 C 1606.67 597.294 1582.43 657.948 1538.53 703.035 C 1484.79 758.013 1423.07 777.3 1347.47 778.016 L 1201.53 778.085 C 1190.67 778.084 1142.83 778.881 1134.27 777.549 C 1129.54 778.438 1113.3 778.126 1107.57 778.126 L 1053.88 778.099 L 931.132 778.024 C 898.93 778.021 863.168 777.065 831.439 781.707 C 808.081 785.125 780.393 792.959 757.556 799.42 C 736.326 805.426 715.448 815.52 695.836 825.366 C 624.346 861.257 565.053 918.637 519.809 984.054 C 505.568 1004.64 493.914 1026.86 481.853 1048.98 C 438.702 961.757 429.074 838.064 441.686 742.387 C 460.069 602.936 527.673 474.081 640.851 388.247 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#FMid)",
    d: "M 481.853 1048.98 C 438.702 961.757 429.074 838.064 441.686 742.387 C 460.069 602.936 527.673 474.081 640.851 388.247 C 639.615 390.445 636.563 394.533 636.974 396.145 C 643.789 391.751 645.817 389.866 654.019 389.602 C 656.211 392.011 655.528 392.164 656.015 396.195 L 658.012 395.28 C 662.957 397.921 664.048 403.307 669.832 407.793 C 673.795 410.866 679.661 414.047 682.929 416.665 C 691.735 424.069 700.762 431.094 708.971 439.245 C 713.552 443.794 715.915 451.052 721.044 456.838 C 732.293 469.722 746.797 479.404 755.351 494.378 C 756.142 495.763 769.71 499.713 771.146 502.493 C 776.844 513.52 784.216 523.744 792.179 533.28 C 797.965 540.209 807.714 545.203 813.525 552.295 C 822.358 564.725 819.694 575.471 836.513 581.378 C 838.082 581.929 844.059 592.563 847.939 592.894 C 867.284 603.22 885.264 614.552 903.349 626.927 C 913.572 633.922 912.51 645.908 923.839 655.651 C 933.431 663.9 940.587 683.095 951.529 693.142 C 957.424 698.554 970.318 702.562 973.226 706.547 C 979.215 714.753 987.002 726.972 986.78 737.561 C 986.586 746.837 981.612 747.623 983.465 757.998 L 985.254 758.81 C 987.036 759.63 987.456 759.754 988.87 761.175 L 986.845 764.088 C 993.954 768.179 1002.89 768.761 1010.83 770.242 C 1043.02 776.247 1075.4 775.104 1107.93 775.988 C 1112.48 776.112 1131.81 776.132 1134.27 777.549 C 1129.54 778.438 1113.3 778.126 1107.57 778.126 L 1053.88 778.099 L 931.132 778.024 C 898.93 778.021 863.168 777.065 831.439 781.707 C 808.081 785.125 780.393 792.959 757.556 799.42 C 736.326 805.426 715.448 815.52 695.836 825.366 C 624.346 861.257 565.053 918.637 519.809 984.054 C 505.568 1004.64 493.914 1026.86 481.853 1048.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#FBase)",
    d: "M 908.766 883.442 C 931.52 882.306 954.507 882.717 977.283 882.885 C 1028.39 883.263 1072.18 883.179 1119.48 906.214 C 1174.54 933.028 1223.34 984.523 1243.05 1042.74 C 1263.49 1103.06 1260.45 1173.17 1232.08 1230.52 C 1216.71 1261.59 1194.41 1288.27 1167.74 1310.21 C 1075.55 1386.08 989.122 1357.45 882.768 1364.99 C 852.109 1367.17 820.528 1374.07 791.446 1384.04 C 779.58 1388.1 768.132 1393.67 756.844 1399.11 C 681.152 1435.6 628.598 1493.68 592.221 1568.67 C 570.343 1617.56 559.956 1668.22 560.855 1721.49 C 561.089 1735.32 559.456 1747.91 561.447 1761.97 C 545.754 1742.71 525.878 1717.54 512.741 1696.2 C 466.861 1621.67 440.498 1533.73 436.803 1446.4 C 434.647 1395.65 437.821 1345.67 447.282 1295.74 C 450.838 1276.98 457.197 1258.3 462.455 1240.05 C 513.788 1061.83 665.844 909.132 854.05 885.915 C 871.595 883.751 890.801 884.025 908.766 883.442 z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "url(#Gradient3)",
    d: "M 1591.72 738.957 C 1610.64 739.428 1630.12 739.395 1649.08 739.646 C 1644.1 755.742 1638.94 771.779 1633.58 787.753 C 1616.29 835.221 1601.19 883.71 1584.15 931.283 C 1581.95 937.42 1579.98 943.641 1578.12 949.888 C 1557.48 950.066 1536.85 950.052 1516.21 949.846 C 1501.65 913.457 1484.81 862.417 1472.97 824.919 C 1465.39 843.717 1458.78 865.513 1452.42 884.984 C 1445.3 906.744 1437.88 928.406 1430.17 949.964 L 1367.75 950.017 C 1352.24 906.715 1337.85 862.097 1322.79 818.589 C 1313.68 792.248 1303.9 766.018 1295.9 739.34 C 1315.14 738.7 1336.87 739.165 1356.3 739.137 C 1370.66 784.915 1385.56 830.523 1400.99 875.952 L 1446.17 739.401 C 1464.55 739.665 1482.93 739.634 1501.31 739.307 C 1516.81 783.814 1531.41 830.394 1546.15 875.302 C 1551.36 862.163 1555.29 847.13 1560.08 833.753 C 1571.21 802.703 1580.7 769.809 1591.72 738.957 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "url(#Gradient2)",
    fillRule: "evenodd",
    d: "M 1164.27 733.806 C 1225.51 724.792 1282.39 767.334 1291.05 828.628 C 1299.71 889.922 1256.84 946.557 1195.5 954.861 C 1134.65 963.097 1078.58 920.651 1069.99 859.858 C 1061.4 799.064 1103.52 742.747 1164.27 733.806 z M 1172.21 789.084 C 1241.53 782.181 1250.04 884.292 1189.13 898.755 C 1178.62 899.717 1169.81 899.366 1160.08 894.662 C 1147.51 888.53 1138.05 877.469 1133.93 864.106 C 1123.45 830.933 1136.8 798.699 1172.21 789.084 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "rgb(98,59,169)",
    fillRule: "evenodd",
    d: "M 700.577 733.812 C 761.582 726.16 817.267 769.335 825.055 830.322 C 832.843 891.309 789.793 947.091 728.824 955.015 C 667.661 962.964 611.663 919.749 603.851 858.568 C 596.039 797.388 639.38 741.487 700.577 733.812 z M 706.139 789.16 C 773.153 782.834 786.684 880.288 723.149 899.215 C 658.783 907.665 638.391 807.334 706.139 789.16 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "rgb(98,59,169)",
    d: "M 999.729 660.53 C 1011.26 660.32 1022.04 660.12 1033.58 660.519 L 1033.64 841.201 C 1033.7 876.833 1034.33 914.228 1033.46 949.739 L 1003.53 949.908 C 992.756 949.965 981.803 949.796 971.015 949.721 L 970.964 660.678 L 999.729 660.53 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "rgb(98,59,169)",
    d: "M 861.988 660.422 C 880.593 659.888 904.402 660.048 922.973 660.638 L 923.088 877.471 C 923.089 885.369 923.989 945.51 921.753 949.395 C 905.483 950.37 877.619 950.144 861.231 949.611 C 860.484 887.433 861.371 824.013 861.352 761.742 L 861.112 700.38 C 861.066 688.197 860.696 672.29 861.988 660.422 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,0)",
    fill: "rgb(160,90,199)",
    d: "M 1782.34 737.356 C 1786.49 736.828 1795.74 736.927 1800.24 736.875 C 1800.64 755.993 1800.24 776.242 1800.13 795.407 C 1797.52 795.247 1794.9 795.104 1792.29 794.976 C 1728.73 791.928 1733.72 836.845 1733.59 883.304 C 1733.62 905.494 1733.46 927.684 1733.1 949.871 C 1723.85 949.761 1676.96 951.152 1671.66 948.803 L 1670.98 946.25 C 1670.95 878.543 1672.25 807.027 1670.85 739.694 L 1729.84 739.438 L 1729.83 763.508 C 1746.16 747.508 1759.23 740.177 1782.34 737.356 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowrStudioFollowr);
export default __webpack_public_path__ + "static/media/followr-studio-followr.7d94e23f25d6d612b165a3dcfea0169f.svg";
export { ForwardRef as ReactComponent };